module.exports = __webpack_public_path__ + "img/konfigurator-tooltip-spiegel-04.ec225a84.jpg";